import PeopleDetailTemplate from './PeopleDetailTemplate';

export { type PeopleDetailTemplateProps } from './PeopleDetailTemplate';
export default PeopleDetailTemplate;
